import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import ExtendLogoFlat from 'src/assets/images/Extend-Logo-Flat.svg'
import BrandPrimaryLogo from 'src/components/BrandPrimaryLogo/BrandPrimaryLogo'
import { SupportedBrands } from 'src/enums'
import Trns, { translateSingleString } from 'src/localization/Trns'
import { selectNullSafeLocaleFromState } from 'src/redux/selectors/auth.selectors'
import { selectBrandName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const StaticPage: React.FC<React.PropsWithChildren> = ({ children }) => {
  const locale = useSelector(selectNullSafeLocaleFromState)
  const brand = useSelector(selectBrandName)
  const isJPM = brand === SupportedBrands.Jpm

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
      `}
    >
      <div
        css={css`
          display: flex;
          flex-direction: column;
          max-width: 720px;
          overflow: auto;
        `}
      >
        <BrandPrimaryLogo
          css={css`
            background-color: ${styleConstants.colors.white};
            box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
            margin-bottom: 60px;
            padding: 20px;
            width: 120px;
          `}
        />
        {children}
        {!isJPM && (
          <div>
            <p
              css={css`
                ${getFontCss(
                  12,
                  styleConstants.colors.gray_darkest,
                  styleConstants.fontFamilies.regular,
                )};
                position: relative;
                margin-top: 50px;
                margin-bottom: 50px;
              `}
            >
              <Trns source={'powered by'} />
              <img
                src={ExtendLogoFlat}
                alt={translateSingleString(locale, 'Extend')}
                css={css`
                  margin-left: 5px;
                  position: absolute;
                  bottom: 2px;
                  height: 12px;
                `}
              />
            </p>
          </div>
        )}
      </div>
    </div>
  )
}

export default StaticPage
